export enum ContactGeneralFormFieldEnum {
    NAME = 'name',
    MOBILE = 'mobile',
    PHONE = 'phone',
    EMAIL = 'email',
    TITLE = 'title',
    IS_PRIMARY = 'isPrimary'
}